import { useChatContext, useGetLicenseFeaturesQuery, useGetTenantSettingsQuery } from 'react-common'
import { FragmentRemoteComponent } from '@constructor/federation/react'
import { Spinner } from '@platform/ui'
// @ts-expect-error
import learnerCoursesRemote from 'virtual:federation/remotes/learner-app'
import { useAuth } from '@/features/auth/useAuth'
import { MFWrapper } from '@/features/microFrontend/learnerMF/MFWrapper'
import { useEventLogger } from '@/hooks/useEventLogger'

export const LearnerAppRemote = () => {
  const { logEvent } = useEventLogger()

  const { isLoading: isUserLoading, user: currentUserResponse } = useAuth()
  const { isLoading: isTenantSettingsLoading, data: tenantSettingsResponse } = useGetTenantSettingsQuery()
  const { isLoading: licensedFeaturesLoading, data: licensedFeaturesResponse } = useGetLicenseFeaturesQuery()

  const isLoading = isUserLoading || isTenantSettingsLoading || licensedFeaturesLoading

  const { openChatWindow, getUnreadCountByChannelId } = useChatContext()

  if (isLoading) {
    return <Spinner />
  }

  return (
    <MFWrapper>
      <FragmentRemoteComponent
        remote={learnerCoursesRemote}
        router={{ base: '/' }}
        entryName="loggedInEntry"
        componentName="learnerMain"
        properties={{
          currentUserResponse,
          tenantSettingsResponse,
          licensedFeaturesResponse: {
            features: licensedFeaturesResponse,
          },
          logEvent,
          communicationHub: {
            openChatWindow,
            getUnreadCountByChannelId,
          },
        }}
        layout="flex"
      />
    </MFWrapper>
  )
}
